/* oxlint-disable no-console -- local Liveblocks auth diagnostics */

export type MedplumRefreshClient = {
  refreshIfExpired: () => Promise<void>
  getAccessToken: () => string | undefined
}

export type LiveblocksRoomHandle = {
  getStatus: () => string
  reconnect: () => void
}

export type LiveblocksClientHandle = {
  getRoom: (roomId: string) => LiveblocksRoomHandle | null
}

type Listener = () => void

const rememberedRoomIds = new Set<string>()
const refreshListeners = new Set<Listener>()

export function rememberLiveblocksRoomId(roomId: string): void {
  rememberedRoomIds.add(roomId)
}

export function clearRememberedLiveblocksRoomIds(): void {
  rememberedRoomIds.clear()
}

export function subscribeMedplumAccessTokenRefresh(
  listener: Listener
): () => void {
  refreshListeners.add(listener)
  return () => {
    refreshListeners.delete(listener)
  }
}

export function notifyMedplumAccessTokenRefresh(): void {
  console.info('[Liveblocks] Medplum token refreshed in place')
  for (const listener of refreshListeners) {
    listener()
  }
}

export async function refreshMedplumIfExpired(
  medplum: MedplumRefreshClient
): Promise<boolean> {
  const before = medplum.getAccessToken()
  await medplum.refreshIfExpired()
  const after = medplum.getAccessToken()
  const refreshed = after !== undefined && after !== before
  if (refreshed) {
    notifyMedplumAccessTokenRefresh()
  }
  return refreshed
}

export function reconnectDisconnectedLiveblocksRooms(
  client: LiveblocksClientHandle
): void {
  for (const roomId of rememberedRoomIds) {
    const room = client.getRoom(roomId)
    if (room?.getStatus() !== 'disconnected') {
      continue
    }
    console.info(
      '[Liveblocks] restarting connection after Medplum token refresh',
      roomId
    )
    room.reconnect()
  }
}
